"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUndo = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M7.535 8.071c.804-.906 2.308-2.073 4.538-2.075 3.13-.003 5.994 2.484 6 6.004.006 3.52-2.919 6-6 6 0 0-1 0-1 1s1 1 1 1A8 8 0 106 6.792V5a1 1 0 00-2 0v4.071a1 1 0 001 1h4.073a1 1 0 000-2H7.535z' }))); };
exports.default = SvgUndo;
//# sourceMappingURL=Undo.js.map